// * passar data de aaaa-mm-dd para dd/mm/aaaa

function formatDate (date) {
  return date !== null ? date.split("-").reverse().join("/") : date;
}

export default formatDate;